export default __webpack_public_path__ + "static/media/product-details-3.05e5b722.jpg";